import { BaseModel } from "sjs-base-model";

export default class NotaAsRead extends BaseModel {
    public readonly idNote: number = 0;
    public readonly isRead: boolean = true;

    constructor(data: Partial<NotaAsRead>) {
        super();

        this.update(data);
    }
}
